import { useMemo, type ReactNode } from 'react'
import { DataAccessContext, type DataAccessMode } from './DataAccessContextDef'

interface DataAccessProviderProps {
  mode: DataAccessMode
  children: ReactNode
}

export function DataAccessProvider({ mode, children }: DataAccessProviderProps) {
  const value = useMemo(() => ({ mode }), [mode])
  return <DataAccessContext.Provider value={value}>{children}</DataAccessContext.Provider>
}
